interface Country {
  id: number;
  alpha2: string;
  alpha3: string;
  ar: string;
  bg: string;
  cs: string;
  da: string;
  de: string;
  el: string;
  en: string;
  eo: string;
  es: string;
  et: string;
  eu: string;
  fi: string;
  fr: string;
  hu: string;
  hy: string;
  it: string;
  ja: string;
  ko: string;
  lt: string;
  nl: string;
  no: string;
  pl: string;
  pt: string;
  ro: string;
  ru: string;
  sk: string;
  sv: string;
  th: string;
  uk: string;
  zh: string;
  'zh-tw': string;
}

/**
 * Gets a country's name in the specified locale
 */
export function getCountryName(alpha2: string, locale: string = 'en'): string {
  const country = countries.find(c => c.alpha2 === alpha2.toLowerCase());
  if (!country) return alpha2.toUpperCase();
  
  const name = country[locale as keyof Country];
  return typeof name === 'string' ? name : country.en;
}

/**
 * Gets a country's data by its alpha2 code
 */
export function getCountry(alpha2: string): Country | undefined {
  return countries.find(c => c.alpha2 === alpha2.toLowerCase());
}

/**
 * Gets all countries
 */
export function getAllCountries(): Country[] {
  return countries;
}

/**
 * Gets all country codes (alpha2)
 */
export function getCountryCodes(): string[] {
  return countries.map(c => c.alpha2);
}

// Import countries data
import countriesData from '~/assets/data/countries.json';
const countries: Country[] = countriesData; 